import { render, staticRenderFns } from "./AuctionForm.vue?vue&type=template&id=56ba76c6&"
import script from "./AuctionForm.vue?vue&type=script&lang=js&"
export * from "./AuctionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports